import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import EventList from './components/EventList';
import NoticeList from './components/NoticeList';

interface Params {
    type: 'EVENT' | 'NOTICE';
}

const BoardActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { type } = params;
    const { t } = useTranslation('board');
    const { stepReplace } = useStepFlow('BoardActivity');
    return (
        <AppScreen>
            <Header title={t('header')} />
            <TabList variant='solid'>
                <TabItem selected={type === 'EVENT'}
                    onClick={() => stepReplace({ type: 'EVENT' })}>
                    {t('tabs.event')}
                </TabItem>
                <TabItem selected={type === 'NOTICE'}
                    onClick={() => stepReplace({ type: 'NOTICE' })} >
                    {t('tabs.notice')}
                </TabItem>
            </TabList>
            {type === 'EVENT' && (
                <EventList/>
            )}
            {type === 'NOTICE' && (
                <NoticeList/>
            )}
        </AppScreen>
    );
};

export default BoardActivity;
